import client from "./client";

// Note the backend mounts this router at the (lowercase, no "s") path
// /communitychat, not /communityChats.
export const getCommunityMessages = (communityId) =>
  client.get(`/communitychat/getChats/${communityId}`);

// The server derives the sender from the auth token — it does not trust a
// client-supplied senderId.
export const sendCommunityMessage = (communityId, content) =>
  client.post("/communitychat/createChat", { communityId, content });
